import { render, staticRenderFns } from "./SupplierManufacturingHaccp.vue?vue&type=template&id=1946421e&scoped=true"
import script from "./SupplierManufacturingHaccp.vue?vue&type=script&lang=js"
export * from "./SupplierManufacturingHaccp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1946421e",
  null
  
)

export default component.exports